import { createSlice } from "@reduxjs/toolkit";
import axios from "axios";

const initialState = {
  SMS: {
    data: [],
    currentPage: 0,
    numberOfPages: 0,
  },
  loading: false,
  error: null,
};

const slice = createSlice({
  name: "sms",
  initialState,
  reducers: {
    getSMSSuccess: (state, { payload }) => {
      state.SMS = payload;
      state.loading = false;
    },
    startLoadingSMS: (state) => {
      state.loading = true;
    },
    hasError: (state, action) => {
      state.error = action.payload;
      state.loading = false;
    },
  },
});

export default slice.reducer;

export const getAllSMSs = ({ accessToken, page }) => {
  const headers = {
    "Content-Type": "application/json",
    Authorization: accessToken,
  };
  return async (dispatch) => {
    try {
      dispatch(slice.actions.startLoadingSMS());
      const res = await axios.get(
        `${process.env.REACT_APP_BACKEND_API}/get-all-sms`,
        { headers }
      );
      dispatch(slice.actions.getSMSSuccess(res.data));
    } catch (error) {
      dispatch(slice.actions.hasError(error.message));
    }
  };
};
